import gql from 'graphql-tag'

import { FRAGMENT_MEDIA, FRAGMENT_PUBLICATION_CATEGORY, FRAGMENTS_SECTIONS } from './shared.gql'

const FRAGMENT_PUBLICATION = gql`
  ${FRAGMENT_PUBLICATION_CATEGORY}
  ${FRAGMENT_MEDIA}
  ${FRAGMENTS_SECTIONS}

  fragment PublicationDto on Publication {
    __typename
    id
    createdAt
    updatedAt
    slug
    date
    title
    excerpt
    subtitle
    categories {
      ...PublicationCategory
    }
    image {
      ...Media
    }
    sections {
      ...SectionBasic
      ...SectionBoxedText
      ...SectionContact
      ...SectionContentMedia
      ...SectionContentSplit
      ...SectionFilterItems
    }
  }
`

export const QUERY_PUBLICATION = gql`
  ${FRAGMENT_PUBLICATION}
  query publication($locale: LocaleInputType!, $where: Publication_where!, $draft: Boolean!) {
    Publications(locale: $locale, draft: $draft, where: $where, trash: false) {
      docs {
        ...PublicationDto
      }
    }
  }
`
